import utils from 'utils'
import revertDialog from '../invoice1/view/revertDialog.html'
import submitResultPage from '../invoice1/view/submitResult.html'

export default class vehicleInvComCtrl {
    constructor($scope, $rootScope, $uibModal, logger, httpRequest, $state, sweetalert, operationService, invoiceOpenService, initSortService, getOvatAmtService, $q, resultTipService, batchHandle, getCodeAndNumber, batchFilterService) {
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [{
                text: '批量提交',
                hasPermit: 'submit_uninvoice_v',
                handler() {
                    $scope.batchOpenInvSubmit()
                },
            }, {
                text: '批量开票',
                hasPermit: 'open_invoice_v',
                handler() {
                    $scope.batchOpenInv()
                },
            }, {
                text: '批量开票打印',
                hasPermit: 'open_invoice_v',
                handler() {
                    $scope.batchOpenInvPrint()
                },
            }, {
                text: '批量删除',
                hasPermit: 'del_invoice_v',
                handler() {
                    $scope.batchDelHandle()
                },
            }, {
                text: '批量回退',
                hasPermit: 'back_invoice_v',
                handler() {
                    $scope.batchFallbackInv()
                },
            }],
        }
        // 用户信息
        const {
            userInfo
        } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
            pageInvType: '1',
            invoiceCode0: '',
            invoiceCode2: '',
            invoiceNumber0: '',
            invoiceNumber2: '',
            taxCode: '',
            CheckCode: '',
            machineNo: '',
            kpfwqh: '',
            limitNumber: 2000,
            isFlowIsValid: false, // 开启审批流
            hasOpenInvPermit: false, // 是否有开票权限
            ifShowSubmitBtn: false, // 是否显示提交按钮
        }
        // 是否启用审核流
        httpRequest.post_qryFlowIsValid({
            approveCode: 'opened_invoice_approve'
        }).then((res) => {
            // 开启审批流
            $scope.pageState.isFlowIsValid = res.data.value
            // 是否有开票权限
            $scope.pageState.hasOpenInvPermit = operationService.hasPermit('open_invoice_v')

            if ($scope.pageState.isFlowIsValid) {
                $scope.pageState.ifShowSubmitBtn = true
            } else if ($scope.pageState.hasOpenInvPermit) {
                $scope.pageState.ifShowSubmitBtn = false
            } else {
                $scope.pageState.ifShowSubmitBtn = true
            }
        })
        $scope.haveCollapsed = false
        // --->无意义语句start
        // 读取金税盘信息
        // invoiceOpenService.checkWithDiskInfo([]).then((res) => {
        //     Object.assign({}, $scope.pageState, res)
        // })
        // <---无意义语句end

        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["invoice_source","is_list","tax_includ","wait_invoice_status","is_pass","profile_type","zero_tax","inv_type","invoice_nature","bill_status","is_privilege","zero_tax", "yes_no_flag", "ovat_tax_rate"]'
        const typecodeArr = ['invoice_source', 'is_list', 'tax_includ', 'wait_invoice_status', 'is_pass', 'profile_type', 'zero_tax', 'inv_type', 'invoice_nature', 'bill_status', 'is_privilege', 'zero_tax', 'yes_no_flag', 'ovat_tax_rate']

        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: ''
                })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr
            }
        })
        // 对外系统
        httpRequest.post_outSystemList().then((res) => {
            $scope.dictData.out_system = toOutSystemdata(res.data.value, 'busSysId', 'busSysName')
        })

        function toOutSystemdata(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    enumTypeCode: null,
                    enumName: '',
                    enumCode: ''
                }
                tempdata.enumCode = list[a][idfield]
                tempdata.enumName = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }

        // 处理校验后错误
        $scope.handleError = function handleError(error) {
            logger.logError(error)
        }
        const aMonth = utils.genPeriodByMonth()
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                applyDateBegin: aMonth.start,
                applyDateEnd: aMonth.end,
                applicant: '',
                billCode: '',
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
                busSysId: '',
                buySysName: '',
                custCreditCode: '',
                custName: '',
                diskCode: '',
                diskId: '',
                invType: '12',
                invoiceCode: '',
                invoiceNumber: '',
                isList: '',
                orgIds: '',
                saleCreditCode: '',
                saleName: '',
                ukeyCode: '',
                ukeyId: '',
                isRed: '',
                invSort: '3',
                custNameCreditCode: '',
                checker: '',
                invoiceSource: '',
                waitInvoiceStatus: '',
                billBatchNo: '',
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                applyDateBegin: aMonth.start,
                applyDateEnd: aMonth.end,
                applicant: '',
                billCode: '',
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
                busSysId: '',
                buySysName: '',
                custCreditCode: '',
                custName: '',
                diskCode: '',
                diskId: '',
                invType: '12',
                invoiceCode: '',
                invoiceNumber: '',
                isList: '',
                orgIds: '',
                saleCreditCode: '',
                saleName: '',
                ukeyCode: '',
                ukeyId: '',
                isRed: '',
                invSort: '3',
                custNameCreditCode: '',
                checker: '',
                invoiceSource: '',
                waitInvoiceStatus: '',
                billBatchNo: '',
            }
        }
        // $scope.reset()
        $scope.resData = []
        $scope.isOnSubmit = false
        $scope.isCollapsed = false
        $scope.customizedConfig = {
            version: 2.7,
            queryForm: [{
                label: '申请日期',
                selected: true,
                default: true,
            }, {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            }, {
                label: '身份证/机构代码证',
                selected: true,
                default: true,
            }, {
                label: '发票性质',
                selected: true,
                default: true,
            }, {
                label: '申请人',
                selected: false,
                default: false,
            }, {
                label: '审核状态',
                selected: false,
                default: false,
            }, {
                label: '数据来源',
                selected: false,
                default: false,
            }, {
                label: '单据编号',
                selected: false,
                default: false,
            }, {
                label: '开票点',
                selected: false,
                default: false,
            }, {
                label: '业务系统',
                selected: false,
                default: false,
            }, {
                label: '扩展1',
                selected: false,
                default: false,
            }, {
                label: '扩展2',
                selected: false,
                default: false,
            }, {
                label: '扩展3',
                selected: false,
                default: false,
            }],
            table: [{
                label: '待开编号',
                selected: false,
                default: false,
            }, {
                label: '发票性质',
                selected: true,
                default: true,
            }, {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            }, {
                label: '身份证/机构代码证',
                selected: true,
                default: true,
            }, {
                label: '合计金额/税额',
                selected: false,
                default: false,
            }, {
                label: '价税合计',
                selected: false,
                default: false,
            }, {
                label: '车辆类型',
                selected: false,
                default: false,
            }, {
                label: '税率',
                selected: false,
                default: false,
            }, {
                label: '开票点',
                selected: false,
                default: false,
            }, {
                label: '关联销售单',
                selected: false,
                default: false,
            }, {
                label: '审核状态',
                selected: false,
                default: false,
            }, {
                label: '数据来源',
                selected: false,
                default: false,
            }, {
                label: '申请日期',
                selected: true,
                default: true,
            }, {
                label: '失败原因',
                selected: false,
                default: false,
            }, {
                label: '申请人',
                selected: false,
                default: false,
            }, {
                label: '单据编号',
                selected: true,
                default: true,
            }, {
                label: '销方开户行及账号',
                selected: false,
                default: false,
            }, {
                label: '扩展1',
                selected: false,
                default: false,
            }, {
                label: '扩展2',
                selected: false,
                default: false,
            }, {
                label: '扩展3',
                selected: false,
                default: false,
            }],
        }
        $scope.pageState.profileType = '29'

        // 红票蓝票
        $scope.isRedList = [{
            enumCode: '0',
            enumName: '蓝票',
        }, {
            enumCode: '1',
            enumName: '红票',
        }, ]
        // 审核状态 waitInvoiceStatus
        $scope.waitInvoiceStatusList = []
        httpRequest.get_dictByType('wait_invoice_status').then((res1) => {
            $scope.waitInvoiceStatusList = $scope.waitInvoiceStatusList.concat(res1.data.value)
        })
        // 已选中数据，以[{invoice}]结构
        $scope.selectedInvoices = []
        $scope.tableDropdownConfig = [{
            label: '详情',
            handler(item) {
                $scope.toDetailPage(item.waitId, item.isRed)
            },
            showWhile() {
                return true
            },
        }, {
            label: '编辑',
            handler(item) {
                $scope.toEditPage(item.waitId, item.isRed)
            },
            showWhile(item, hasPermit) {
                return item.authMap.WAIT_EDIT && hasPermit('add_invoice_v')
            },
        }, {
            label: '提交',
            handler(item, index) {
                $scope.submitInvoice(item, index)
            },
            showWhile(item, hasPermit) {
                return item.authMap.WAIT_COMMIT && hasPermit('submit_uninvoice_v')
            },
        }, {
            label: '开票',
            handler(item, index) {
                invoiceOpenService.checkWithDiskInfo([item]).then((diskInfo) => {
                    failReasonConfirm([item]).then(() => {
                        Object.assign($scope.pageState, diskInfo)
                        $scope.openInvoice(item, false, index)
                    })
                }, $scope.handleError)
            },
            showWhile(item, hasPermit) {
                return item.authMap.WAIT_BILLING && hasPermit('open_invoice_v')
            },
        }, {
            label: '开票打印',
            handler(item, index) {
                invoiceOpenService.checkWithDiskInfo([item]).then((diskInfo) => {
                    failReasonConfirm([item]).then(() => {
                        Object.assign($scope.pageState, diskInfo)
                        $scope.openInvoice(item, true, index)
                    })
                }, $scope.handleError)
                queryList()
            },
            showWhile(item, hasPermit) {
                return item.authMap.WAIT_BILLING_PRINT && hasPermit('open_invoice_v')
            },
        }, {
            label: '回退',
            handler(item, index) {
                $scope.reductionOvatInvoiceWait(item, index)
            },
            showWhile(item, hasPermit) {
                return item.authMap.WAIT_FALLBACK && hasPermit('back_invoice_v')
            },
        }, {
            label: '删除',
            handler(item) {
                $scope.toDelinvoice(item.waitId)
            },
            showWhile(item, hasPermit) {
                return item.authMap.WAIT_DELETE && hasPermit('del_invoice_v')
            },
        }, ]

        // 表头排序
        $scope.orderMap = initSortService('vehicleInvoiceParam')
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('vehicleInvoiceParam', JSON.stringify($scope.param))
            queryList()
        }
        // let isSearch = false
        // $scope.$watch('param', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('outputManage.FOManage.vehicleInvoice') != -1) {
        //         isSearch && sessionStorage.setItem('vehicleInvoiceParam', JSON.stringify($scope.param))
        //     }
        // })
        // 查询列表
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const {
                adValoremTotal,
                totalAmt,
                totalTaxamt
            } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            httpRequest.post_getInvoiceWaitStatics($scope.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt
                }
            })
        }

        const queryList = function queryList() {
            $scope.param = sessionStorage.vehicleInvoiceParam ? JSON.parse(sessionStorage.vehicleInvoiceParam) : $scope.param
            httpRequest.post_getOvatInvoiceWaitList($scope.param).then((res) => {
                $scope.isOnSubmit = false
                $scope.resData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
                $scope.param.pageNum = res.data.value.pageNum
                $scope.selectedInvoices = []
            })
            getData()
        }
        httpRequest.get_getUserCustomized($scope.pageState.profileType).then(res => {
            if (res.data.value) {
                let orderMap = JSON.parse(res.data.value).orderMap
                if (orderMap) {
                    $scope.orderMap = orderMap
                }
            }
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) {
                $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            }
            sessionStorage.setItem('vehicleInvoiceParam', JSON.stringify($scope.param))
            queryList()
        })
        // 数据来源变化
        $scope.invoiceSourceChange = function invoiceSourceChange() {
            if ($scope.param.param.invoiceSource !== 'table' || $scope.param.param.invoiceSource !== 'interface') {
                $scope.param.param.buySysName = ''
                $scope.param.param.busSysId = ''
            }
        }
        // tab变化
        $scope.isCollapsed = false // 批量下拉
        $scope.goAddVehicleInvPage = function goAddVehicleInvPage(type) {
            switch (type) {
                case 'addBlueInv':
                    $state.go('outputManage.FOManage.vehicleInvoice.add')
                    break
                case 'addRedInv':
                    $state.go('outputManage.FOManage.vehicleInvoice.addred')
                    break
            }
        }

        // 返回开票点名称
        $scope.filterUkeyName = function filterUkeyName(id) {
            if (id === null) {
                return id
            }
            if (JSON.parse(localStorage.user_info).sysUkeyList === null) {
                return id
            }
            const fliterUkeyNameArr = JSON.parse(localStorage.user_info).sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }
        // 搜索
        $scope.searchlist = function searchlist() {
            $scope.isOnSubmit = true
            $scope.currentPage = 1
            sessionStorage.setItem('vehicleInvoiceParam', JSON.stringify($scope.param))
            queryList()
        }
        // 提交
        $scope.submitInvoice = function submitInvoice(v) {
            httpRequest.post_submitOvatInvoiceWait(v.waitId, '提交成功').then(() => {
                queryList()
            })
        }

        function openBatchSubmitResult(result) {
            $uibModal.open({
                template: submitResultPage,
                controller: ['$scope', 'items1', '$uibModalInstance', function ctrl(scope, items1, $uibModalInstance) {
                    scope.errorList = items1
                    scope.cancel = function close() {
                        $uibModalInstance.close()
                    }
                    scope.ok = function close() {
                        $uibModalInstance.close()
                    }
                }],
                openedClass: 'mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return result
                    },
                },
            }).result.then(() => {
                queryList()
            })
        }

        function failReasonConfirm(invList) {
            let hasErrorList = []
            invList.forEach(invoice => {
                if (invoice.description) {
                    hasErrorList.push({
                        infoId: invoice.waitId,
                        errorMsg: invoice.description,
                    })
                }
            })
            const defered = $q.defer()
            if (hasErrorList.length === 0) {
                defered.resolve()
                return defered.promise
            }
            // 强行公用批量提交结果页面
            return $uibModal.open({
                template: submitResultPage,
                controller: [
                    '$scope', '$uibModalInstance', 'sweetalert',
                    function ctrl(scope, uibModalInstance, sweetalert) {
                        scope.errorList = hasErrorList
                        scope.msg = '下列发票上次开具失败，请确认是否已经修复'
                        scope.cancel = function cancel() {
                            uibModalInstance.dismiss()
                        }
                        scope.ok = function ok() {
                            let flag = false
                            scope.errorList.forEach(invoice => {
                                if (invoice.errorMsg && (invoice.errorMsg.slice(0, 4) == '4003' || invoice.errorMsg.slice(0, 4) == '4005')) {
                                    flag = true
                                }
                            })
                            if (flag) {
                                sweetalert.confirm('操作提醒', '发票上次写库失败，请先到开票软件进行发票修复后，再点击确认。避免重复开具该发票，造成跳号错觉').then(() => {
                                    uibModalInstance.close()
                                })
                            } else {
                                uibModalInstance.close()
                            }
                        }
                    },
                ],
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
            }).result
        }

        function submitCallback(res) {
            utils.loaded()
            if (res.data.value.error) {
                const params = {
                    sourceCount: res.data.value.total,
                    errorCount: res.data.value.error,
                    list: res.data.value.messageList,
                    title: '提交'
                }
                resultTipService.openErrorModal(params, queryList)
            } else {
                logger.logSuccess(`提交成功${res.data.value.total}张票据`)
                queryList()
            }
        }
        // 批量提交
        $scope.batchOpenInvSubmit = function batchOpenInvSubmit() {

            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请先选择发票行')
                return
            }
            batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                condition: {
                    word: 'WAIT_COMMIT',
                    val: true
                },
                text: '提交'
            }).then(arr => {
                const waitIds = []
                for (let i = 0; i < arr.length; i++) {
                    waitIds.push(arr[i].waitId)
                }
                batchHandle.open().then(data => {
                    utils.loading('系统正在批量处理中，请耐心等待... ')
                    if (data.startRow || data.endRow) {
                        const subParams = $.extend(data, $scope.param)
                        httpRequest.post_batchSubmitWaitRange(subParams).then(res => {
                            submitCallback(res)
                        })
                    } else {
                        httpRequest.post_batchSubmitOvatInvoiceWait(waitIds).then((res) => {
                            submitCallback(res)
                        })
                    }
                })

            })
        }
        // 批量删除
        $scope.batchDelHandle = function batchDelHandle() {

            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请先选择发票行')
                return
            }
            batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                condition: {
                    word: 'WAIT_DELETE',
                    val: true
                },
                text: '删除'
            }).then(arr => {
                const waitIds = []
                for (let i = 0; i < arr.length; i++) {
                    waitIds.push(arr[i].waitId)
                }
                sweetalert.confirm('操作提醒', '确认删除发票？').then(() => {
                    httpRequest.post_batchDelOvatInvoiceWait(waitIds).then((res) => {
                        if (res.data.success) {
                            logger.logSuccess('删除成功')
                            queryList()
                        } else {
                            logger.logError(res.data.errorMsg)
                        }
                    })
                })
            })
        }
        // 获取选中id数组
        function getSelectedArr() {
            const selectedArr = []
            $scope.selectedInvoices.forEach((invoice) => {
                selectedArr.push(invoice.waitId)
            })
            return selectedArr
        }
        // 检验是否选中了相同种类发票
        function checkSelectedSameInvType(arr, oldid, newid) {
            const selectedArr = []
            const o = arr
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid] && o[m][newid]) {
                    selectedArr.push(o[m][newid])
                }
            }
            const newArr = Array.from(new Set(selectedArr))
            return newArr
        }

        // 编辑
        $scope.toEditPage = function (v, isRed) {
            if (v === undefined) {
                logger.logError('参数错误，请刷新重试')
            } else if (isRed == '0') {
                // console.log(v)
                $state.go('outputManage.FOManage.vehicleInvoice.edit', {
                    waitId: v
                })
            } else {
                $state.go('outputManage.FOManage.vehicleInvoice.editRed', {
                    waitId: v
                })
            }
        }
        // 查看关联销售单
        $scope.relatedBill = function (item) {
            if (item.billNum === 0) {
                return
            }
            if (item.waitId === undefined) {
                return
            }
            $state.go('outputManage.FOManage.vehicleInvoice.relatedBill', {
                waitId: item.waitId
            })
        }
        // 详情
        $scope.toDetailPage = function (v, isRed) {
            let url
            if (v === undefined) {
                logger.logError('参数错误，请刷新重试')
                return
            }
            if (isRed == '0') {
                // console.log(v)
                url = $state.href('outputManage.FOManage.vehicleInvoice.detail', {
                    waitId: v
                }, {
                    reload: true
                })
            } else {
                url = $state.href('outputManage.FOManage.vehicleInvoice.detailRed', {
                    waitId: v
                }, {
                    reload: true
                })
            }
            window.open(url, '_blank')
        }
        // 删除
        $scope.toDelinvoice = function (v) {
            const msg = '确认删除此发票?'
            sweetalert.swal({
                title: '删除提醒',
                text: msg,
                // type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#0096e7',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnConfirm: true,
                closeOnCancel: true,
            }, (isConfirm) => {
                if (isConfirm) {
                    // 确定处理
                    httpRequest.post_delOvatInvoiceWait({
                        waitId: v,
                    }).then(() => {
                        logger.logSuccess('删除成功')
                        queryList()
                    })
                }
            })
        }
        // 开票信息
        // 选中开票行
        $scope.invoice = {}
        // 金税盘信息
        let taxCode = ''
        let CheckCode = ''
        let machineNo = ''
        let kpfwqh = ''
        const dybz = false // 打印标志
        // 获取金税盘信息
        function getTaxInfo() {
            taxCode = $scope.pageState.taxCode
            CheckCode = $scope.pageState.CheckCode
            machineNo = $scope.pageState.machineNo
            kpfwqh = $scope.pageState.kpfwqh
        }
        // 批量开票
        $scope.batchOpenInv = function batchOpenInv() {
            getTaxInfo()
            const waitIdsArr = $scope.selectedInvoices
            const waitIdsArrLen = waitIdsArr.length
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请先选择发票行')
                return
            }
            utils.loading('开票信息获取中')
            $scope.invoiceStr = ''

            let i = 0

            function fn(ukeyList, invType) {
                if (i >= ukeyList.length) {
                    utils.loaded()

                    invoiceOpenService.checkWithDiskInfo($scope.selectedInvoices).then((diskInfo) => {
                        failReasonConfirm($scope.selectedInvoices).then(() => {
                            Object.assign($scope.pageState, diskInfo)
                            sweetalert.confirm('操作提醒', `当前执行批量开票的单据份数为${$scope.selectedInvoices.length}张，请确认${$scope.invoiceStr}`).then(() => {
                                const serial = 0
                                const submitWaitIds = getSelectedArr()
                                httpRequest.post_batchSubmitOvatInvoiceWait(submitWaitIds).then((res11) => {
                                    $scope.errorNum = 0
                                    plPreIssueOpen(waitIdsArr, false, waitIdsArrLen, serial)
                                })
                            })
                        })
                    }, $scope.handleError)
                } else {
                    getCodeAndNumber.getStr(ukeyList[i], invType).then(str => {
                        i++
                        $scope.invoiceStr += str
                        fn(ukeyList, invType)
                    })
                }
            }
            getCodeAndNumber.getUkeyList($scope.selectedInvoices).then((ukeyList, invType) => {
                fn(ukeyList, 12)
            })
        }

        // 批量开票打印
        $scope.batchOpenInvPrint = function batchOpenInvPrint() {
            getTaxInfo()
            const waitIdsArr = $scope.selectedInvoices
            const waitIdsArrLen = waitIdsArr.length
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请先选择发票行')
                return
            }
            utils.loading('开票信息获取中')
            $scope.invoiceStr = ''

            let i = 0

            function fn(ukeyList, invType) {
                if (i >= ukeyList.length) {
                    utils.loaded()

                    invoiceOpenService.checkWithDiskInfo($scope.selectedInvoices).then((diskInfo) => {
                        failReasonConfirm($scope.selectedInvoices).then(() => {
                            Object.assign($scope.pageState, diskInfo)
                            // 批量打印不能选不同种类的发票
                            const checkSameInvType = checkSelectedSameInvType($scope.resData, 'selected', 'invType')
                            if (checkSameInvType.length > 1) {
                                logger.logError('请选择同种类发票进行开票并打印')
                                return
                            }
                            // let invoiceNumber
                            // let invoiceCode
                            // invoiceNumber = vechileInvoiceNumber
                            // invoiceCode = vechileInvoiceCode
                            // <p>发票代码：${invoiceCode}</p>
                            // <p>发票起始号码：${invoiceNumber}</p>
                            const tipsHtml = `<div>
                            <h5 style="font-size: 16px; font-weight: 500; color: #333; margin-bottom: 20px;">您正在进行打印发票的操作，请确保您选择的发票是否与打印机上的纸质发票对应！</h3>
                                <p>发票种类：机动车发票</p>
                                <p>发票份数：${waitIdsArrLen}</p>${$scope.invoiceStr}
                            </div>`
                            // 确认弹窗
                            sweetalert.confirm('', tipsHtml).then(() => {
                                const serial = 0
                                const waitIds = getSelectedArr()
                                httpRequest.post_batchSubmitOvatInvoiceWait(waitIds).then((res11) => {
                                    $scope.errorNum = 0
                                    plPreIssueOpen(waitIdsArr, true, waitIdsArrLen, serial)
                                })
                            })
                        })
                    }, $scope.handleError)
                } else {
                    getCodeAndNumber.getStr(ukeyList[i], invType).then(str => {
                        i++
                        $scope.invoiceStr += str
                        fn(ukeyList, invType)
                    })
                }
            }
            getCodeAndNumber.getUkeyList($scope.selectedInvoices).then((ukeyList, invType) => {
                fn(ukeyList, 12)
            })
        }

        // 回退
        $scope.reductionOvatInvoiceWait = function (item, $index) {
            httpRequest.post_checkReductionOvatInvoiceWait(item.waitId).then((res) => {
                if (!res.data.success) {
                    logger.logError(res.data.message)
                }
                if (res.data.value === null) {
                    reductOvatInvoiceWait(item, $index)
                } else {
                    // 确认弹窗
                    $uibModal.open({
                        template: revertDialog,
                        controller: ['$scope', '$uibModalInstance',
                            function ctrl(scope, uibModalInstance) {
                                scope.revertData = res.data.value
                                scope.cancel = function cancel() {
                                    uibModalInstance.dismiss()
                                }
                                scope.ok = function ok() {
                                    uibModalInstance.close()
                                }
                            }
                        ],
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-md',
                        resolve: {
                            items1() {
                                return res.data.value
                            },
                        },
                    }).result.then(() => {
                        reductOvatInvoiceWait(item, $index)
                    })
                }
            })
        }
        // 批量回退
        $scope.batchFallbackInv = function batchFallbackInv() {
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请选择发票')
                return
            }
            batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                condition: {
                    word: 'WAIT_FALLBACK',
                    val: true
                },
                text: '回退'
            }).then(arr => {
                const waitIds = []
                for (let i = 0; i < arr.length; i++) {
                    
                    waitIds.push(arr[i].waitId)
                }
                sweetalert.confirm('操作提醒', `回退后需要重新提交检测，确认回退吗？`).then(() => {
                    httpRequest.post_batchReductionOvatInvoiceWait(waitIds).then((res) => {
                        if (res.data.success) {
                            if (!res.data.value.error) {
                                logger.logSuccess('回退成功')
                            } else {
                                const failCount = res.data.value.error
                                const successCount = arr.length - failCount
                                logger.logSuccess(`本次回退${arr.length}条，成功${successCount}条，失败${failCount}条，回退失败的请检查后再次操作！`)
                            }
                            queryList()
                        } else {
                            logger.logError('回退失败')
                        }
                    })
                })

            })
        }

        function reductOvatInvoiceWait(item) {
            httpRequest.post_reductionOvatInvoiceWait(item.waitId, '回退成功').then(() => {
                queryList()
            })
        }
        // 批量发票开具
        function plPreIssueOpen(arr, dyflag, len, serial) {
            const actionMsg = !dyflag ? '开具' : '开具打印'
            const invoice = arr[serial]
            const msg = `请您耐心等待···正在${actionMsg}第${serial + 1}张发票；发票种类机动车发票`
            const opening = window.layer.msg(msg, {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            const dyPromise = dyflag ? invoiceOpenService.openPrint(invoice) : invoiceOpenService.open(invoice)
            dyPromise.catch((error) => {
                $scope.errorNum += 1
                // httpRequest.post_writeOvatInvoiceFailReason({
                //     reason: error.retmsg,
                //     waitId: invoice.waitId,
                // })
            }).finally(() => {
                if (serial < len - 1) {
                    serial += 1
                    plPreIssueOpen(arr, dyflag, len, serial)
                } else if (serial === len - 1) {
                    window.layer.close(opening)
                    logger.logMsg({
                        title: '操作结果',
                        icon: 1,
                        message: `共计${len}张发票,成功${len - $scope.errorNum}张，失败${$scope.errorNum}张！`,
                    })
                }
                queryList()
            })
        }

        // 单条开具
        $scope.openInvoice = function (v, dyflag, index) {
            getTaxInfo()
            if (taxCode === '' || taxCode === undefined || taxCode === null) {
                logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
                return
            }
            const actionMsg = !dyflag ? '开具' : '开具打印'
            const msg = `请您耐心等待···正在${actionMsg}；发票种类机动车发票`
            const opening = window.layer.msg(msg, {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            // 开票
            const dyPromise = dyflag ? invoiceOpenService.openPrint(v) : invoiceOpenService.open(v)
            dyPromise.then(() => {
                logger.logSuccess('开具成功')
                queryList()
            }, (error) => {
                // httpRequest.post_writeOvatInvoiceFailReason({
                //     reason: error.retmsg,
                //     waitId: v.waitId,
                // })
                v.description = error.retmsg
                logger.logError(error.retmsg)
                queryList()
            }).finally(() => {
                window.layer.close(opening)
                queryList()
            })
        }

        // 状态按钮滑过
        $scope.dropdown_rowhover_state = function (row, flag) {
            row.dropdowstatenhover = flag
            // 返回审核流
        }
        // 关联销售单移入移出
        $scope.toggleDrop = function toggleDrop(item, flag) {
            item.toggleDrophover = flag
            if (flag && item.billNum > 0) {
                httpRequest.post_getOvatInvoiceWaitBillList({
                    pageNum: 1,
                    pageSize: 10,
                    param: item.waitId,
                }).then((res) => {
                    item.toggleDropList = res.data.value.list
                })
            }
        }

        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('vehicleInvoiceParam', JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage.vehicleInvoiceParam ? JSON.parse(sessionStorage.vehicleInvoiceParam).param : {
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    applicant: '',
                    billCode: '',
                    blueInvoiceCode: '',
                    blueInvoiceNumber: '',
                    busSysId: '',
                    buySysName: '',
                    custCreditCode: '',
                    custName: '',
                    diskCode: '',
                    diskId: '',
                    invType: '12',
                    invoiceCode: '',
                    invoiceNumber: '',
                    isList: '',
                    orgIds: '',
                    saleCreditCode: '',
                    saleName: '',
                    ukeyCode: '',
                    ukeyId: '',
                    isRed: '',
                    invSort: '3',
                    custNameCreditCode: '',
                    checker: '',
                    invoiceSource: '',
                    waitInvoiceStatus: '',
                    billBatchNo: '',
                },
            }))
            queryList()
        }
        // 下载导入模板
        $scope.downOvatBill = function () {
            window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_INVOICE_VEHICLE?accessToken=${localStorage.getItem('id_token')}`)
        }
        $scope.open = function () {
            if (!JSON.parse(localStorage.user_info).sale) {
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
                return
            }
            $scope.item = {
                queryOvatBillList: queryList,
                code: 'OVAT_INVOICE_VEHICLE',
            }
            const modalInstance = $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return $scope.item
                    },
                },
            })
            modalInstance.result.then(() => {
                // console.log(222)
                queryList()
            }, () => {
                // console.log(111)
            })
        }
    }
}
vehicleInvComCtrl.$inject = ['$scope', '$rootScope', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'operationService', 'invoiceOpenService', 'initSortService', 'getOvatAmtService', '$q', 'resultTipService', 'batchHandle', 'getCodeAndNumber', 'batchFilterService']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/vehicleInvoice/list.js